import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../login/authSlice';
import { MetricsDataTable } from './components/MetricsDataTable';
import './MetricsAdmin.scss';
import { MetricsCreation } from './components/metricsCreation/MetricsCreation';

export const MetricsAdmin = () => {
    const loggedUser = useSelector(selectCurrentUser);
    const [showCreationForm, setShowCreationForm] = useState(false);
    const [editingMetricId, setEditingMetricId] = useState<number | null>(null);

    const handleCreateMetric = () => {
        setEditingMetricId(null);
        setShowCreationForm(true);
    };

    const handleEditMetric = (metricId: number) => {
        setEditingMetricId(metricId);
        setShowCreationForm(true);
    };

    const handleCancel = () => {
        setShowCreationForm(false);
        setEditingMetricId(null);
    };

    const handleSave = () => {
        setShowCreationForm(false);
        setEditingMetricId(null);
    };

    return (
        <div>
            {/* Welcome Card */}
            <div className="card shadow bg-body rounded mt-3 border-0">
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-4 text-start">
                            <span id="label_employeename" className="mt-1 ms-3 d-inline-block">
                                {`Welcome back, ${loggedUser}!`}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content Card */}
            <div className="card shadow bg-body rounded mt-4 border-0">
                <div className="card-body p-4">
                    <div className="row">
                        <div className="col-md-12">
                            {showCreationForm ? (
                                <MetricsCreation 
                                    metricId={editingMetricId}
                                    onCancel={handleCancel} 
                                    onSave={handleSave} 
                                />
                            ) : (
                                <>
                                    <h4 className="metrics-admin-title mb-4">Metrics Admin</h4>
                                    
                                    {/* Tab Panel Area */}
                                    <div className="metrics-admin-tabs">
                                        <div className="tab-header mb-3">
                                            <span className="tab-item active">All Created Metrics</span>
                                        </div>
                                        
                                        {/* Metrics Data Table */}
                                        <MetricsDataTable 
                                            onCreateMetric={handleCreateMetric}
                                            onEditMetric={handleEditMetric}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};